import React, { Component } from 'react';
import { WardrobesConfigsContext } from '../../../contexts/WardrobesConfigsContext';
import Wardrobe from './Wardrobe';
import * as THREE from 'three';
import OrbitControls from 'three-orbitcontrols';
import GLTFLoader from 'three-gltf-loader';
import {
  newPhantomMat,
  shadowMat,
  lightMat,
  lightMatExt,
  plotnoMatInterior,
  mirrorMaterials,
} from './Materials';
import Dimension from './Dimension';
import Label3d from './Label3d';
import { measurements, sceneTraverse, loadTexture, loadSkyBox } from './utils';
import difference from 'lodash/difference';

const getDifferencesIndex = (firstList, secondList) => {
  const idsFirst = firstList.map(item => item.id);
  const idsSecond = secondList.map(item => item.id);

  const values = difference(idsFirst, idsSecond);
  const index = idsFirst.indexOf(values[0]);
  return index;
};

var limitLoop = function (fn, fps, rAFInstance) {
  var then = new Date().getTime();

  fps = fps || 60;
  var interval = 1000 / fps;

  return (function loop(time) {
    rAFInstance.id = requestAnimationFrame(loop);

    // again, Date.now() if it's available
    var now = new Date().getTime();
    var delta = now - then;

    if (delta > interval) {
      // Update time
      // now - (delta % interval) is an improvement over just
      // using then = now, which can end up lowering overall fps
      then = now - (delta % interval);

      // call the fn
      fn();
    }
  })(0);
};

class BrwScene extends Component {
  _isMounted = false;
  static contextType = WardrobesConfigsContext;

  constructor(props) {
    super();
    this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    // this.renderer.setClearColor( 0xff0000, 0);
    this.resetScene(props);
    this.preloader = this.preloader.bind(this);
    this.rAF = React.createRef();
    this.rAF = { id: null };

    this.labels3d = new THREE.Group();

    this.overallScale = 1;

    // console.log(process.env.PUBLIC_URL);
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   return false;
  // }

  resizeScene() {
    this.marginHeight = 540;
    this.marginWidth = 380;
    this.marginTop = 70;

    if (window.matchMedia('(max-width: 1279px)').matches) {
      this.marginHeight = 300;
      this.marginWidth = 0;
      this.marginTop = 80;
    }
    if (window.matchMedia('(min-width: 1400px)').matches) {
      this.marginHeight = 680;
      this.marginWidth = 500;
      this.marginTop = 50;
    }
  }

  resetScene(props) {
    this.resizeScene();

    this.downShift = 100;

    this.scene = new THREE.Scene();
    this.scene.background = new THREE.Color(0xffffff);

    this.scene.visible = false;

    window.brwScene = this.scene;

    this.camera = new THREE.PerspectiveCamera(
      20,
      (window.innerWidth - this.marginWidth) / this.marginHeight,
      0.4,
      2000,
    );
    window.brwCamera = this.camera;

    window.brwRenderer = this.renderer;
    // this.renderer.shadowMap.enabled = true;

    this.canvas = this.renderer.domElement;

    if (props.orbitMode === true) {
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
    }
    this.wardrobes = [];

    this.mouse = new THREE.Vector2();
    this.raycaster = new THREE.Raycaster();

    this.loaded = false;

    this.lights = new THREE.Group();
    this.lights.name = 'LightsGroup';
    this.dimensions = new THREE.Group();
    this.dimensions.name = 'DimensionsGroup';

    this.phantoms = new THREE.Group();
    this.phantoms.name = 'Phantoms';
    this.phantomSides = new THREE.Group();
    this.phantomSides.name = 'PhantomSides';
    this.Phantom_L = new THREE.Object3D();
    this.Phantom_R = new THREE.Object3D();

    this.shadows = new THREE.Group();
    this.shadows.name = 'ShadowsGroup';
    this.ShadowCatcher_SL = new THREE.Object3D();
    this.ShadowCatcher_SC = new THREE.Object3D();
    this.ShadowCatcher_SA = new THREE.Object3D();
    this.ShadowCatcher_SR = new THREE.Object3D();
    this.ShadowCatcher_SZ = new THREE.Object3D();

    this.wardrobesConfigs = null;

    this.loadCounter = 0;
    this.envTexture = null;
  }

  componentDidMount() {
    this._isMounted = true;
    this.wardrobesConfigs = this.context.wardrobesConfigs;
    this.upperFronts = this.wardrobesConfigs[0].dimensions.y > 218;
    this.prepareScene();
    this.props.orbitMode === true && this.setControls();
    this.setLights();

    this.camera.aspect = (window.innerWidth - this.marginWidth) / this.marginHeight;
    // this.camera.updateProjectionMatrix();
    this.renderer.setSize(window.innerWidth - this.marginWidth, this.marginHeight);

    window.addEventListener('resize', this.onWindowResize, false);
    this.renderer.domElement.addEventListener('mousemove', this.onMouseMove, false);
    this.renderer.domElement.addEventListener('mousedown', this.onMouseDown, false);

    this.camera.position.z = 1100;

    this.gltf = null;

    // console.log('mount view:',process.env.PUBLIC_URL);

    this.gltfLoader = new GLTFLoader();
    this.gltfLoader.setCrossOrigin('anonymous');
    this.gltfLoader.load(
      `${process.env.PUBLIC_URL}/gltf/FLEX_All_Elements.glb`,
      gltf => {
        this.loaded = true;
        this.gltf = gltf;
        this.buildWardrobe();
        this.populateScene();
        this.makeShadows();
        this.preloadTextures();
        this.loadCounter++;
      },
      xhr => {
        // called while loading is progressing
        let progres = xhr.total ? (xhr.loaded / xhr.total) * 100 : 100;
      },
      error => {
        // called when loading has errors
        console.error('An error happened', error);
      },
    );
    limitLoop(this.animate, 5, this.rAF);
  }

  checkLoaded() {
    if (this.loadCounter > 3) {
      this.scene.visible = true;
      this.props.changeStatus(true);
    }
  }

  preloadTextures() {
    //Preload hardcoded

    /*var promises = [];
        const texturesList = window['textures'];
        Object.keys(texturesList).forEach(key => {
          // tutaj rozdzielić na grupy!
          textures[key] = texturesList[key].src;
        });

        Object.keys(texturesList).forEach(key => {
          promises.push(
            loadTexture(texturesList[key].path)
              .then(texture => {
                texturedMaterials[key].map = texture;
                texture.wrapS = THREE.RepeatWrapping;
                texture.wrapT = THREE.RepeatWrapping;
                texturedMaterials[key].needsUpdate = true;
              })
              .catch(err => {}),
          );
        });

        Promise.all(promises).then(() => {
          this.loadCounter++;
          this.checkLoaded();
        }); */

    //Preload skyBox
    const urls = [
      `${process.env.PUBLIC_URL}/skyBox/nx.jpg`,
      `${process.env.PUBLIC_URL}/skyBox/nx.jpg`,
      `${process.env.PUBLIC_URL}/skyBox/ny.jpg`,
      `${process.env.PUBLIC_URL}/skyBox/ny.jpg`,
      `${process.env.PUBLIC_URL}/skyBox/nx.jpg`,
      `${process.env.PUBLIC_URL}/skyBox/ny.jpg`,
    ];

    //Setting envMap
    loadSkyBox(urls).then(envTexture => {
      Object.keys(mirrorMaterials).forEach(key => (mirrorMaterials[key].envMap = envTexture));
      this.loadCounter++;
      this.checkLoaded();
    });
  }

  preloader(how) {
    // console.log('Load ' , how, this.loadCounter);
    // if(how === true){
    //   this.loadCounter++;
    // }
  }

  onMouseMove = event => {
    //300,540,680

    this.mouse.x = (event.clientX / (window.innerWidth - this.marginWidth)) * 2 - 1;
    this.mouse.y =
      -((event.clientY + window.pageYOffset - this.marginTop) / this.canvas.clientHeight) * 2 + 1;

    this.checkSelection();
  };

  setControls = () => {
    this.controls.enablePan = false;
    this.controls.enableDamping = true;
    this.controls.dampingFactor = 0.05;
    this.controls.enableZoom = false;
    this.controls.enableRotate = true;
  };

  setLights = () => {
    var ambientLight = new THREE.AmbientLight(0xffffff, 0.7);
    this.lights.add(ambientLight);

    var light = new THREE.PointLight(0xffffff, 0.7, 2000);
    light.position.set(-550, 500, 1000);
    light.castShadow = true;
    this.lights.add(light);
    this.scene.add(this.lights);
  };

  prepareScene = () => {
    this.mount.appendChild(this.renderer.domElement);
  };

  animate = () => {
    this.renderer.render(this.scene, this.camera);
  };

  checkSelection = () => {
    let intersectObjects;
    const wardrobesConfigs = this.context.wardrobesConfigs;
    if (this.loaded === true) {
      this.raycaster.setFromCamera(this.mouse, this.camera);
      switch (this.props.configuratorMode) {
        case 3:
          let fronts = this.wardrobes[this.props.activeWardrobe].getFronts().children[0];
          let intersectFronts = this.raycaster.intersectObjects(fronts.children);
          if (intersectFronts.length > 0) {
            this.selectedFront = intersectFronts[0].object;
            const aName = this.selectedFront.name.split('_');
            if (this.upperFronts === true) {
              this.renderer.domElement.style.cursor = 'pointer';
            } else if (aName[2] !== '3') {
              this.renderer.domElement.style.cursor = 'pointer';
            } else {
              this.renderer.domElement.style.cursor = 'default';
            }
          } else {
            this.renderer.domElement.style.cursor = 'default';
          }
          break;
        case 5:
          let frontsHandle = this.wardrobes[this.props.activeWardrobe].getFronts().children[0];
          let intersectFrontsHandles = this.raycaster.intersectObjects(frontsHandle.children);
          if (intersectFrontsHandles.length > 0) {
            this.selectedFront = intersectFrontsHandles[0].object;
            const aName = this.selectedFront.name.split('_');
            if (aName[0] !== 'Front') {
              this.renderer.domElement.style.cursor = 'pointer';
            }
          } else {
            this.renderer.domElement.style.cursor = 'default';
          }
          break;
        case 6:
          intersectObjects = this.raycaster.intersectObjects(this.zones.children);
          if (intersectObjects.length > 0) {
            if (intersectObjects[0].object.name)
              this.zones.children.find(zone => zone.name === 'left').material.opacity = 0;
            this.zones.children.find(zone => zone.name === 'center').material.opacity = 0;
            this.zones.children.find(zone => zone.name === 'right').material.opacity = 0;
            this.zones.children.find(
              zone => zone.name === intersectObjects[0].object.name,
            ).material.opacity = 0.5;
            const zoneName = intersectObjects[0].object.name;
            if (wardrobesConfigs[this.props.activeWardrobe].dimensions.x < 200) {
              if (wardrobesConfigs[this.props.activeWardrobe].is_corner === true) {
                if (zoneName !== 'right' && zoneName !== 'center') {
                  this.renderer.domElement.style.cursor = 'pointer';
                }
              } else if (zoneName !== 'center') {
                this.renderer.domElement.style.cursor = 'pointer';
              }
            } else {
              this.renderer.domElement.style.cursor = 'pointer';
            }
          } else {
            this.zones.children.find(zone => zone.name === 'left').material.opacity = 0;
            this.zones.children.find(zone => zone.name === 'center').material.opacity = 0;
            this.zones.children.find(zone => zone.name === 'right').material.opacity = 0;
            this.renderer.domElement.style.cursor = 'default';
          }
          break;
        case 11:
          intersectObjects = this.raycaster.intersectObjects(this.phantomSides.children);
          if (intersectObjects.length > 0) {
            if (
              intersectObjects[0].object !== this.selected &&
              intersectObjects[0].object.name === 'Phantom_L'
            ) {
              // this.selected = intersectObjects[0].object;
              intersectObjects[0].object.material.color.setHex(0xa8a8a8);
            }
            if (
              intersectObjects[0].object !== this.selected &&
              intersectObjects[0].object.name === 'Phantom_R'
            ) {
              // this.selected = intersectObjects[0].object;
              intersectObjects[0].object.material.color.setHex(0xa8a8a8);
            }
          } else {
            this.phantomSides.children.forEach(phantom => {
              phantom.material.color.setHex(0xc0c0c0);
            });
            // this.selected = null;
          }
          break;
        default:
      }
    }
  };

  onMouseDown = () => {
    if (this.loaded === true) {
      const wardrobesConfigs = this.context.wardrobesConfigs;

      let intersectObjects = null;
      this.raycaster.setFromCamera(this.mouse, this.camera);

      switch (this.props.configuratorMode) {
        case 3:
          let fronts = this.wardrobes[this.props.activeWardrobe].getFronts().children[0];
          let intersectFronts = this.raycaster.intersectObjects(fronts.children);
          if (intersectFronts.length > 0) {
            this.selectedFront = intersectFronts[0].object;
            // this.props.setActiveFrontPanel(this.selectedFront.name);

            const aName = this.selectedFront.name.split('_');

            if (aName[0] === 'Ram' || aName[0] === 'Lus') {
              aName[2] = '0';
            }

            if (this.upperFronts === false && aName[2] === '3') {
              // console.log('empty');
            } else {
              this.props.setActiveFrontPanel(aName[0] + '_' + aName[1] + '_' + aName[2]);
              this.wardrobes[this.props.activeWardrobe].setSelectedFronts([
                parseInt(aName[1]) + parseInt(aName[2]),
              ]);
            }
          } else {
            this.selectedFront = null;
            this.props.setActiveFrontPanel();
            this.wardrobes[this.props.activeWardrobe].setSelectedFronts([]);
          }
          break;
        case 5:
          let frontsHandle = this.wardrobes[this.props.activeWardrobe].getFronts().children[0];
          let intersectFrontsHandles = this.raycaster.intersectObjects(frontsHandle.children);
          if (intersectFrontsHandles.length > 0) {
            this.selectedFront = intersectFrontsHandles[0].object;
            const aName = this.selectedFront.name.split('_');
            if (aName[0] === 'Ram' || aName[0] === 'Lus') {
              aName[2] = '0';
            }
            this.props.setActiveFrontPanel(aName[0] + '_' + aName[1] + '_' + aName[2]);
            this.wardrobes[this.props.activeWardrobe].setSelectedFronts([
              parseInt(aName[1]) + parseInt(aName[2]),
            ]);
          } else {
            this.selectedFront = null;
            this.props.setActiveFrontPanel();
            this.wardrobes[this.props.activeWardrobe].setSelectedFronts([]);
          }
          break;
        case 6:
          intersectObjects = this.raycaster.intersectObjects(this.zones.children);

          if (intersectObjects.length > 0) {
            if (intersectObjects[0].object !== null) {
              const zoneName = intersectObjects[0].object.name;
              if (wardrobesConfigs[this.props.activeWardrobe].dimensions.x < 200) {
                if (wardrobesConfigs[this.props.activeWardrobe].is_corner === true) {
                  if (zoneName !== 'right' && zoneName !== 'center') {
                    this.props.setZone(zoneName);
                  }
                } else if (zoneName !== 'center') {
                  this.props.setZone(zoneName);
                }
              } else {
                this.props.setZone(zoneName);
              }
            }
          }
          break;
        case 10:
          this.props.changeConfiguratorMode(8);
          break;
        case 11:
          intersectObjects = this.raycaster.intersectObjects(this.phantomSides.children);

          if (intersectObjects.length > 0) {
            if (
              intersectObjects[0].object !== null &&
              intersectObjects[0].object.name === 'Phantom_L'
            ) {
              this.props.addWardrobe('L');
            }
            if (
              intersectObjects[0].object !== null &&
              intersectObjects[0].object.name === 'Phantom_R'
            ) {
              this.props.addWardrobe('R');
            }
          } else {
            this.phantomSides.children.forEach(phantom => {
              this.props.changeConfiguratorMode(8);
            });
          }
          break;
        default:
      }
    }
  };

  populateScene() {
    /* DIMENSIONS */

    this.widthDimension = new Dimension().getDimension();
    this.angleDimension = new Dimension().getDimension();
    this.heightDimension = new Dimension().getDimension();
    this.depthDimension = new Dimension().getDimension();
    this.depthDimension2 = new Dimension().getDimension();

    this.widthDimension.name = 'widthDimension';
    this.angleDimension.name = 'angleDimension';
    this.heightDimension.name = 'heightDimension';
    this.depthDimension.name = 'depthDimension';
    this.depthDimension2.name = 'depthDimension2';

    this.heightDimension.rotation.z = (Math.PI * 90) / 180;
    this.depthDimension.rotation.y = (Math.PI * 90) / 180;
    this.angleDimension.rotation.y = -(Math.PI * 90) / 180;

    this.dimensions.add(this.widthDimension);
    this.dimensions.add(this.heightDimension);
    this.dimensions.add(this.depthDimension);
    this.dimensions.add(this.angleDimension);
    this.dimensions.add(this.depthDimension2);

    this.labelWidth = new Label3d(200 + 'cm');
    this.labelAngle = new Label3d(200 + 'cm');
    this.labelHeight = new Label3d(240 + 'cm', 90);
    this.labelDepth = new Label3d(66 + 'cm', 5);
    this.labelDepth2 = new Label3d(45 + 'cm', -5);

    this.dimensions.add(this.labelWidth.getLabel());
    this.dimensions.add(this.labelAngle.getLabel());
    this.dimensions.add(this.labelHeight.getLabel());
    this.dimensions.add(this.labelDepth.getLabel());
    this.dimensions.add(this.labelDepth2.getLabel());

    this.scene.add(this.dimensions);
  }

  prepareAO() {
    if (this.ShadowCatcher_SC !== undefined) {
      loadTexture(`${process.env.PUBLIC_URL}/Shadows/ShadowWall.jpg`).then(texture => {
        const shadowMaterial = new THREE.MeshBasicMaterial({
          map: texture,
        });
        this.ShadowCatcher_SC.material = shadowMaterial;
        this.ShadowCatcher_SL.material = shadowMaterial;
        this.ShadowCatcher_SR.material = shadowMaterial;
        this.ShadowCatcher_SA.material = shadowMaterial;
        this.ShadowCatcher_SZ.material = shadowMaterial;

        this.scene.add(this.shadows);

        this.loadCounter++;
        this.checkLoaded();
      });

      loadTexture(`${process.env.PUBLIC_URL}/Shadows/Shadow.png`).then(shadowTexture => {
        plotnoMatInterior.map = shadowTexture;
        shadowMat.map = shadowTexture;
        this.loadCounter++;
        this.checkLoaded();
      });

      loadTexture(`${process.env.PUBLIC_URL}/Lights/Light.png`).then(lightTexture => {
        lightMat.map = lightTexture;
        lightMatExt.map = lightTexture;
        this.loadCounter++;
        this.checkLoaded();
      });
    }
  }

  checkType(types = [], wardrobeTypes = {}) {
    let isCorner = false;
    types.map(index => {
      if (wardrobeTypes.hasOwnProperty(index)) {
        isCorner = true;
      }
    });

    return isCorner;
  }

  buildWardrobe() {
    let gltfScene = this.gltf.scene;

    const wardrobesConfigs = this.context.wardrobesConfigs;

    if (this.props.pathname === '/summary') {
      this.props.changeConfiguratorMode(8);
      Object.keys(wardrobesConfigs).forEach(key => {
        this.makeWardrobe(wardrobesConfigs[key], key, gltfScene, false);
      });
    } else {
      switch (this.props.pathname) {
        case '/wardrobe-fronts-configuration':
          this.props.changeConfiguratorMode(3);
          break;
        case '/wardrobe-handles-configuration':
          this.props.changeConfiguratorMode(5);
          break;
        case '/accessories-configuration':
          this.props.changeConfiguratorMode(6);
          break;
        default:
          this.props.changeConfiguratorMode(1);
      }

      this.makeWardrobe(
        wardrobesConfigs[this.props.activeWardrobe],
        this.props.activeWardrobe,
        gltfScene,
        false,
      );
    }

    // this.phantoms.position.y = -this.downShift;
    // this.scene.add(this.phantoms);
    this.setPhantoms();
    // this.refreshGeometry();
  }

  makeWardrobe(wardrobe, index, gltf, insert = false) {
    const newWardrobe = new Wardrobe(wardrobe, index, gltf);
    const newWardrobeGeo = newWardrobe.getWardrobe();
    newWardrobeGeo.name = 'Wardrobe_' + index;

    let bodyMaterial;

    if (wardrobe.safo == 'F57-SZF1DL/240/66-GF' || wardrobe.safo == 'F57-SZF1DL/218/66-GF') {
      bodyMaterial =
        'https://flex-api.brw.pl/upload/products/material/21uveo8/1knjuy0/FZGYmSiyK1NZeefV2isH1PsB71gJTCasPWFBumDW.jpeg';
    } else {
      bodyMaterial = wardrobe.img;
    }

    newWardrobe.setBodyMaterial(bodyMaterial);

    newWardrobe.setFrontsMaterial(wardrobe.fronts, wardrobe.is_hinged);

    if (this.props.configuratorMode > 5) {
      newWardrobe.setWardrobe(wardrobe);
      newWardrobe.setAccessories(wardrobe.accessories, true);
    }

    if (newWardrobe.isSlidingFront) {
      newWardrobe.setHandlesMaterial(wardrobe.handles);
    }

    this.zones = newWardrobe.getZones();

    if (this.props.configuratorMode === 6) {
      this.zones.visible = true;
    }

    if (insert) {
      this.wardrobes.splice(index, 0, newWardrobe);
    } else {
      this.wardrobes[index] = newWardrobe;
    }
    this.scene && this.scene.add(newWardrobeGeo);
  }

  setPhantoms() {
    const wardrobesConfigs = this.context.wardrobesConfigs;
    let scaleL = wardrobesConfigs[0].dimensions.z > 66 ? 66 : wardrobesConfigs[0].dimensions.z;
    let scaleR =
      wardrobesConfigs[wardrobesConfigs.length - 1].dimensions.z > 66
        ? 66
        : wardrobesConfigs[wardrobesConfigs.length - 1].dimensions.z;

    this.gltf.scene.traverse(object => {
      if (object.name === 'Phantom_Box') {
        this.Phantom_L = object.clone();
        this.Phantom_R = object.clone();
        this.Phantom_L.name = 'Phantom_L';
        this.Phantom_R.name = 'Phantom_R';
        this.Phantom_L.material = newPhantomMat;
        this.Phantom_R.material = newPhantomMat.clone();
      }
    });
    this.Phantom_L.scale.set(100, wardrobesConfigs[0].dimensions.y, scaleL);
    this.Phantom_R.scale.set(100, wardrobesConfigs[0].dimensions.y, scaleR);
    this.phantomSides.add(this.Phantom_L);
    this.phantomSides.add(this.Phantom_R);
    this.phantomSides.visible = false;
    this.scene.add(this.phantomSides);
  }

  makeShadows() {
    this.gltf.scene.traverse(object => {
      if (object.name === 'ShadowCatcher_SC') {
        this.ShadowCatcher_SC = object.clone();
        this.shadows.add(this.ShadowCatcher_SC);
        this.ShadowCatcher_SA = object.clone();
        this.ShadowCatcher_SA.name = 'ShadowCatcher_SA';

        this.ShadowCatcher_SA.visible = false;
        this.shadows.add(this.ShadowCatcher_SA);
      }
      if (object.name === 'ShadowCatcher_SL') {
        this.ShadowCatcher_SL = object.clone();
        this.shadows.add(this.ShadowCatcher_SL);
        this.ShadowCatcher_SZ = object.clone();
        this.ShadowCatcher_SZ.name = 'ShadowCatcher_SZ';

        this.ShadowCatcher_SZ.visible = false;
        this.shadows.add(this.ShadowCatcher_SZ);
      }
      if (object.name === 'ShadowCatcher_SR') {
        this.ShadowCatcher_SR = object.clone();
        this.shadows.add(this.ShadowCatcher_SR);
      }
    });

    this.prepareAO();
  }

  setShadows(
    wardrobeAngle,
    actualPos,
    anglePos,
    activeWardrobe,
    xAngleShift,
    zAngleShift,
    angleType,
  ) {
    const wardrobesConfigs = this.context.wardrobesConfigs;

    activeWardrobe = activeWardrobe === wardrobesConfigs.length ? 0 : activeWardrobe;

    const firstConfig = wardrobesConfigs[0];
    const lastConfig = wardrobesConfigs[wardrobesConfigs.length - 1];
    const activeConfig = wardrobesConfigs[activeWardrobe];

    const activeType = activeConfig.safo.split('/')[0];

    let height = firstConfig.dimensions.y;
    let firstDepth = firstConfig.dimensions.z;
    let lastDepth = lastConfig.dimensions.z;
    let activeDepth = activeConfig.dimensions.z;

    let shiftX = 0;
    let overlap = 0;

    let centerXscale = actualPos;

    let down = 0;

    if (
      wardrobeAngle === true &&
      lastConfig.is_corner === false &&
      firstConfig.is_corner === false
    ) {
      this.ShadowCatcher_SA.scale.set(actualPos - anglePos + 150, height / 2, lastDepth);
      this.ShadowCatcher_SA.visible = true;
      this.ShadowCatcher_SZ.visible = true;
    } else if (activeType === 'F57-SZFN1D') {
      firstDepth = 66;
      lastDepth = 66;
      overlap = 0;
      if (lastConfig.is_corner === false && firstConfig.is_corner === false) {
        this.ShadowCatcher_SA.visible = true;
        this.ShadowCatcher_SZ.visible = true;
      } else {
        this.ShadowCatcher_SA.visible = false;
        this.ShadowCatcher_SZ.visible = false;
      }
    } else if (angleType === 'F57-SZF1DR') {
      if (this.props.configuratorMode > 7 && wardrobesConfigs.length > 1) {
        if (lastConfig.is_corner) {
          this.ShadowCatcher_SA.visible = false;
          this.ShadowCatcher_SZ.visible = false;
        } else if (firstConfig.is_corner) {
          this.ShadowCatcher_SA.visible = true;
          this.ShadowCatcher_SZ.visible = true;
          firstDepth = 48;
          shiftX = 4;
        }
      } else {
        firstDepth = 48;
        shiftX = 4;
      }
    } else {
      if (wardrobeAngle === true && lastConfig.is_corner === false) {
        this.ShadowCatcher_SA.visible = true;
        this.ShadowCatcher_SZ.visible = true;
      } else {
        this.ShadowCatcher_SA.visible = false;
        this.ShadowCatcher_SZ.visible = false;
      }
      firstDepth = activeDepth;
    }

    if (this.props.configuratorMode < 8) {
      this.ShadowCatcher_SA.visible = false;
      this.ShadowCatcher_SZ.visible = false;
    }

    this.ShadowCatcher_SA.position.set(
      anglePos - xAngleShift,
      0.5,
      actualPos - anglePos + zAngleShift,
    );
    this.ShadowCatcher_SA.rotation.y = (-90 * Math.PI) / 180;
    this.ShadowCatcher_SA.scale.set(
      actualPos - anglePos + xAngleShift + overlap,
      height / 2,
      lastDepth,
    );

    this.ShadowCatcher_SZ.scale.set(100, height / 2, lastDepth);
    this.ShadowCatcher_SZ.position.set(
      anglePos - xAngleShift,
      0,
      actualPos - anglePos + zAngleShift,
    );
    this.ShadowCatcher_SZ.rotation.y = (-90 * Math.PI) / 180;

    this.ShadowCatcher_SR.scale.set(100, height / 2, firstDepth);
    this.ShadowCatcher_SR.position.x = shiftX;

    this.ShadowCatcher_SC.scale.set(centerXscale + overlap, height / 2, firstDepth);
    this.ShadowCatcher_SC.position.x = centerXscale + shiftX + overlap;

    this.ShadowCatcher_SL.scale.set(100, height / 2, firstDepth);
    this.ShadowCatcher_SL.position.set(centerXscale + overlap + shiftX, down, 0);

    this.shadows.position.y = -2;
  }

  deleteWardrobe(index) {
    const deletedWardrobe = this.wardrobes[index];
    this.scene.remove(deletedWardrobe.getWardrobe());
    this.wardrobes.splice(index, 1);
    this.props.setWardrobeActive(0);
    this.renderer.renderLists.dispose();
  }

  refreshGeometry() {
    if (this.loadCounter > 3) {
      const wardrobesConfigs = this.context.wardrobesConfigs;
      let activeWardrobe = this.props.activeWardrobe;
      const measureResult = measurements(wardrobesConfigs);
      /*
        console.log(
         'Refresh - Active:',
          activeWardrobe,
          // wardrobesConfigs[activeWardrobe].handles,
          // 'AFronts:',
          // this.props.activeFronts,
          // 'Load:',
          // this.loadCounter,
          // 'Mode ',
          // this.props.configuratorMode,
          wardrobesConfigs.map(c => c.id ),
          // this.wardrobes.map(w => w.id),
        );
      */
      let actualPos = 0;
      let wardrobeAngle = false;
      let anglePos = 0;
      let angleWidth = 105;
      let xAngleShift = 45;
      let zAngleShift = 0;
      let angleType = 'F57-SZFN1D';

      if (this.props.configuratorMode > 7) {
        // SUMMARY
        /* DELETE WARDROBE */
        if (wardrobesConfigs.length < this.wardrobes.length) {
          const index = getDifferencesIndex(this.wardrobes, wardrobesConfigs);
          this.deleteWardrobe(index);
        }

        /* ADD WARDROBE */
        if (wardrobesConfigs.length > this.wardrobes.length) {
          const index = getDifferencesIndex(wardrobesConfigs, this.wardrobes);
          this.makeWardrobe(wardrobesConfigs[index], index, this.gltf.scene, true);
        }

        const itemOrder = wardrobesConfigs.map(item => item.id);
        this.wardrobes = this.wardrobes.sort(function (a, b) {
          var A = a.id,
            B = b.id;

          if (itemOrder.indexOf(A) > itemOrder.indexOf(B)) {
            return 1;
          } else {
            return -1;
          }
        });

        /* HIGHLIGHT WARDROBE */
        this.phantoms.children.forEach((phantom, index) => {
          phantom.visible = false;
          if (index === this.props.highlightedWardrobe) {
            phantom.visible = true;
          }
        });

        wardrobesConfigs.forEach((config, index) => {
          if (wardrobesConfigs.length === this.wardrobes.length) {
            const wardrobe = this.wardrobes[index];
            const dimensions = config.dimensions;
            if (wardrobe) {
              wardrobe.setWardrobe(wardrobesConfigs[index]);
              if (wardrobeAngle === true) {
                if (
                  wardrobe.type !== 'F57-SZFN1D' ||
                  wardrobe.type !== 'F57-SZF1DL' ||
                  wardrobe.type !== 'F57-SZF1DR'
                ) {
                  wardrobe.getWardrobe().rotation.y = (-Math.PI / 180) * 90;
                }
                wardrobe.getWardrobe().position.z = actualPos - anglePos + zAngleShift;
                wardrobe.getWardrobe().position.x = anglePos - xAngleShift;
              } else {
                wardrobe.getWardrobe().position.z = 0;
                wardrobe.getWardrobe().rotation.y = 0;
                wardrobe.getWardrobe().position.x = actualPos;
                anglePos += dimensions.x;
              }

              if (
                wardrobe.type === 'F57-SZFN1D' ||
                wardrobe.type === 'F57-SZF1DL' ||
                wardrobe.type === 'F57-SZF1DR'
              ) {
                if (wardrobe.type === 'F57-SZFN1D') {
                  xAngleShift = 68;
                  zAngleShift = 35;
                } else if (wardrobe.type === 'F57-SZF1DR') {
                  xAngleShift = 62;
                  zAngleShift = 50;
                  angleType = 'F57-SZF1DR';
                } else {
                  xAngleShift = 44;
                  zAngleShift = 4;
                  angleType = 'F57-SZF1DL';
                }
                wardrobeAngle = true;
                angleWidth = actualPos;
              }
            }
            actualPos += dimensions.x;

            /* DOOR HIDING when withoutDoors = true */
            wardrobe.openDoors(
              wardrobesConfigs[index].withoutDoor === true ? false : this.props.opened,
            );

            /* HIGHLIGHT WARDROBE */
            if (index === this.props.highlightedWardrobe) {
              wardrobe.showPhantom(true);
            } else {
              wardrobe.showPhantom(false);
            }

            if (this.props.notHighlightedWardrobe !== undefined) {
              wardrobe.showPhantom(index !== this.props.notHighlightedWardrobe);
            }
          }
        });

        /* SIDE PHANTOMS */
        if (this.props.configuratorMode === 11) {
          if (wardrobeAngle === true) {
            this.Phantom_R.rotation.y = (-Math.PI / 180) * 90;
            this.Phantom_R.position.z = actualPos - anglePos + zAngleShift;
            this.Phantom_R.position.x = anglePos - xAngleShift;
          } else {
            this.Phantom_R.position.x = actualPos;
          }
          if (this.wardrobes[activeWardrobe]) {
            this.Phantom_L.position.x = -100;
          }
          this.phantomSides.visible = true;
        } else {
          this.phantomSides.visible = false;
        }
        if (actualPos > 300) {
          this.overallScale = 350 / actualPos;
        }
      } else {
        // OTHERS VIEWS THEN SUMMARY
        if (this.wardrobes[activeWardrobe]) {
          let config;

          if (wardrobesConfigs[activeWardrobe] === undefined) {
            config = wardrobesConfigs[0];
            // activeWardrobe = 0;
          } else {
            config = wardrobesConfigs[activeWardrobe];
          }
          actualPos = config.dimensions.x;

          if (config.is_corner === true) {
            angleType = config.safo.split('/')[0];
          }

          if (this.props.configuratorMode === 3 || this.props.configuratorMode === 5) {
            this.wardrobes[activeWardrobe].openDoors(true);
            this.wardrobes[activeWardrobe].setFrontsMaterial(config.fronts, config.is_hinged);
            this.wardrobes[activeWardrobe].setHandlesMaterial(config.handles);
          } else {
            this.wardrobes[activeWardrobe].openDoors(false);
          }
          this.wardrobes[activeWardrobe].setWardrobe(config);
          if (this.props.configuratorMode > 1 && this.props.configuratorMode < 7) {
            this.zones.getObjectByName('left_outline').visible = true;
            if (this.props.configuratorMode === 6 && this.props.activeZone !== null) {
              this.zones.getObjectByName('left_outline').visible = false;
              this.zones.getObjectByName(this.props.activeZone + '_outline').visible = true;
            }

            //FRONT PRESELECTION
            if (this.props.activeFronts.length > 0) {
              if (this.wardrobes[activeWardrobe] !== undefined) {
                if (this.props.configuratorMode === 3) {
                  this.wardrobes[activeWardrobe].setSelectedFronts(this.props.activeFronts);
                } else if (
                  this.props.configuratorMode === 5 &&
                  this.wardrobesConfigs[activeWardrobe].is_hinged
                ) {
                  this.wardrobes[activeWardrobe].setSelectedFronts(this.props.activeFronts);
                }
              }
            }
            if (this.props.configuratorMode > 5) {
              this.wardrobes[activeWardrobe].setAccessories(config.accessories, true);
            }
          } else {
            // SET START ACCESORIES
            let startAccessories = {};

            if (config.dimensions.z > 45) {
              if (config.dimensions.x > 200) {
                startAccessories = {
                  left: [{ safo: 'F57-DR', slug: 'f57_dr.glb', altitude: 85 }],
                  center: [{ safo: 'F57-DR', slug: 'f57_dr.glb', altitude: 85 }],
                  right: [{ safo: 'F57-DR', slug: 'f57_dr.glb', altitude: 85 }],
                };
              } else if (config.dimensions.x > 75) {
                startAccessories = {
                  left: [{ safo: 'F57-DR', slug: 'f57_dr.glb', altitude: 85 }],
                  center: [],
                  right: [{ safo: 'F57-DR', slug: 'f57_dr.glb', altitude: 85 }],
                };
              } else {
                startAccessories = {
                  left: [{ safo: 'F57-DR', slug: 'f57_dr.glb', altitude: 85 }],
                  center: [],
                  right: [],
                };
              }
            } else {
              startAccessories = {
                left: [],
                center: [],
                right: [],
              };
            }

            let bodyMaterial;

            if (
              this.context.wardrobesConfigs[activeWardrobe].safo == 'F57-SZF1DL/240/66-GF' ||
              this.context.wardrobesConfigs[activeWardrobe].safo == 'F57-SZF1DL/218/66-GF'
            ) {
              bodyMaterial =
                'https://flex-api.brw.pl/upload/products/material/21uveo8/1knjuy0/FZGYmSiyK1NZeefV2isH1PsB71gJTCasPWFBumDW.jpeg';
            } else {
              bodyMaterial = wardrobesConfigs[activeWardrobe].img;
            }

            this.wardrobes[activeWardrobe].setBodyMaterial(bodyMaterial);
            this.wardrobes[activeWardrobe].setAccessories(startAccessories, false);
          }
        }
      }

      /* DIMENSIONS */
      if (
        this.props.configuratorMode > 7 &&
        this.dimensions.children[0] &&
        this.props.dimensions === true
      ) {
        this.widthDimension.scale.x = anglePos - xAngleShift;
        this.widthDimension.position.y = wardrobesConfigs[activeWardrobe].dimensions.y + 10;
        this.widthDimension.position.z = wardrobesConfigs.length === 1 ? zAngleShift : 0;
        this.heightDimension.scale.x = wardrobesConfigs[activeWardrobe].dimensions.y;
        this.heightDimension.position.x = -30;
        this.heightDimension.position.z = measureResult.depth === 103 ? -66 : -measureResult.depth;

        this.depthDimension.scale.x =
          wardrobesConfigs.length === 1
            ? wardrobesConfigs[activeWardrobe].dimensions.z
            : measureResult.depth;
        this.depthDimension.position.z = wardrobesConfigs.length === 1 ? zAngleShift : 0;
        this.depthDimension.position.y = wardrobesConfigs[activeWardrobe].dimensions.y + 10;

        if (wardrobeAngle === true && measureResult.cornerIndex < wardrobesConfigs.length - 1) {
          this.angleDimension.scale.x = actualPos - anglePos + zAngleShift;
          this.angleDimension.position.x = anglePos - xAngleShift;
          this.angleDimension.position.y = wardrobesConfigs[activeWardrobe].dimensions.y + 10;
          this.depthDimension2.scale.x = measureResult.depth1;
          this.depthDimension2.position.x = anglePos - xAngleShift;
          this.depthDimension2.position.y = wardrobesConfigs[activeWardrobe].dimensions.y + 10;
          this.depthDimension2.position.z = actualPos - anglePos + zAngleShift;
        } else {
          this.widthDimension.scale.x = anglePos;
          this.angleDimension.visible = false;
          this.depthDimension2.visible = false;
        }

        if (wardrobeAngle === true && wardrobesConfigs.length > 1) {
          if (
            measureResult.cornerIndex === 0 ||
            measureResult.cornerIndex < wardrobesConfigs.length - 1
          ) {
            if (measureResult.cornerIndex === 0) {
              this.angleDimension.scale.x = actualPos - anglePos + zAngleShift + 66;
              this.angleDimension.position.z = -66;
            } else {
              this.angleDimension.position.z = 0;
            }
            this.angleDimension.visible = true;
            this.depthDimension2.visible = true;
          }

          if (
            measureResult.cornerIndex === wardrobesConfigs.length - 1 ||
            measureResult.cornerIndex > 0
          ) {
            this.widthDimension.visible = true;
            this.depthDimension.visible = true;
          } else {
            this.widthDimension.visible = false;
            this.depthDimension.visible = false;
          }
        } else {
          this.widthDimension.visible = true;
          this.depthDimension.visible = true;
        }
        this.refreshLabels();
      }

      this.dimensions.visible = this.props.dimensions;

      /* LIGHTS & SHADOWS */

      this.setShadows(
        wardrobeAngle,
        actualPos,
        anglePos,
        activeWardrobe,
        xAngleShift,
        zAngleShift,
        angleType,
      );

      /* RESCALE SCENE */

      let cameraAngle = 25;
      let cameraShift = 45;
      let lightShift = 0;

      if (wardrobeAngle === true && measureResult.cornerIndex !== wardrobesConfigs.length - 1) {
        cameraShift = 75;
        cameraAngle = 45;
        lightShift = 200 / this.overallScale;
      } else if (
        wardrobeAngle === true &&
        measureResult.cornerIndex === 0 &&
        wardrobesConfigs.length > 1
      ) {
        cameraAngle = 70;
        cameraShift = 45;
      }

      this.lights.position.x = (actualPos / 2) * this.overallScale + cameraShift - lightShift;
      this.lights.position.z = lightShift;
      this.scene.rotation.y = (cameraAngle * Math.PI) / 180;
      this.scene.position.x = (-actualPos / 2) * this.overallScale + cameraShift;
      this.scene.position.y = (-wardrobesConfigs[0].dimensions.y / 2) * this.overallScale;
      this.scene.scale.set(this.overallScale, this.overallScale, this.overallScale);
    }
  }

  refreshLabels() {
    const wardrobesConfigs = this.context.wardrobesConfigs;
    const measureResult = measurements(wardrobesConfigs);
    const activeWardrobe = this.props.activeWardrobe;
    let insert1 = 0;
    let insert2 = 0;

    let tempScale = 1 / this.overallScale;

    switch (this.marginHeight) {
      case 300:
        tempScale = (1 / this.overallScale) * 2;
        break;
      case 540:
        tempScale = (1 / this.overallScale) * 1.2;
        break;
      default:
    }
    insert1 = measureResult.depth1 == 66 && measureResult.cornerDepth == 70 ? 19.3 : 0;
    insert2 = measureResult.depth == 66 && measureResult.cornerWidth == 66 ? 19.3 : 0;
    this.labelWidth.setText(
      parseFloat(
        (
          Number(measureResult.overallWidth) -
          Number(measureResult.angleWidth) +
          Number(insert1)
        ).toFixed(2),
      ) + ' cm',
    );
    this.labelWidth.setScale(tempScale);
    this.labelWidth.getLabel().position.y = this.widthDimension.position.y + 15;
    this.labelWidth.getLabel().position.x = this.widthDimension.scale.x / 2;
    this.labelWidth.getLabel().position.z = this.widthDimension.position.z;

    this.labelHeight.setText(measureResult.overallHeight + ' cm');
    this.labelHeight.setScale(tempScale);
    this.labelHeight.getLabel().position.y = this.widthDimension.position.y / 2;
    this.labelHeight.getLabel().position.x = this.heightDimension.position.x - 20;
    this.labelHeight.getLabel().position.z = this.heightDimension.position.x - 20;

    this.labelDepth.setText(measureResult.depth + ' cm');
    this.labelDepth.setScale(tempScale);
    this.labelDepth.getLabel().position.y = this.widthDimension.position.y + 15;
    this.labelDepth.getLabel().position.x = this.depthDimension.position.x;
    this.labelDepth.getLabel().position.z = -15;

    if (
      measureResult.isCorner === true &&
      measureResult.cornerIndex < wardrobesConfigs.length - 1
    ) {
      this.labelDepth2.setText(measureResult.depth1 + ' cm');
      this.labelDepth2.setScale(tempScale);
      this.labelDepth2.getLabel().position.y = this.widthDimension.position.y + 15;
      this.labelDepth2.getLabel().position.x = this.depthDimension2.position.x + 45;
      this.labelDepth2.getLabel().position.z = this.depthDimension2.position.z + 20;
      this.labelAngle.setText(
        parseFloat(
          (
            Number(measureResult.angleWidth) +
            Number(measureResult.cornerDepth) +
            Number(insert2)
          ).toFixed(2),
        ) + ' cm',
      );
      this.labelAngle.setScale(tempScale);
      this.labelAngle.getLabel().position.y = this.widthDimension.position.y + 15;
      this.labelAngle.getLabel().position.x = this.angleDimension.position.x;
      this.labelAngle.getLabel().position.z = this.angleDimension.scale.x / 2;
      this.labelAngle.getLabel().visible = true;
      this.labelDepth2.getLabel().visible = true;
    } else {
      this.labelAngle.getLabel().visible = false;
      this.labelDepth2.getLabel().visible = false;
    }
    if (
      measureResult.isCorner === true &&
      measureResult.cornerIndex === 0 &&
      wardrobesConfigs.length > 1
    ) {
      this.labelAngle.getLabel().position.z = this.angleDimension.scale.x / 2 - 45;
      this.labelWidth.getLabel().visible = false;
      this.labelDepth.getLabel().visible = false;
      this.labelAngle.getLabel().visible = true;
      this.labelDepth2.getLabel().visible = true;
    } else {
      this.labelWidth.getLabel().visible = true;
      this.labelDepth.getLabel().visible = true;
    }
  }

  toScreenPosition(obj, camera, renderer) {
    var vector = new THREE.Vector3();

    var widthHalf = 0.5 * renderer.context.canvas.width;
    var heightHalf = 0.5 * renderer.context.canvas.height;

    obj.position.clone();

    let pos = obj.position.project(this.camera);

    vector.x = vector.x * widthHalf + widthHalf;
    vector.y = -(vector.y * heightHalf) + heightHalf;

    // console.log(vector.x, widthHalf * 2);

    return {
      x: vector.x,
      y: vector.y,
    };
  }

  onWindowResize = () => {
    this.resizeScene();

    if (this.renderer.context.canvas.height !== this.marginHeight) {
      this.refreshLabels();
    }

    this.camera.aspect = (window.innerWidth - this.marginWidth) / this.marginHeight;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(window.innerWidth - this.marginWidth, this.marginHeight);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.refreshGeometry();
  }

  dispose() {
    // dispose geometries and materials in scene
    sceneTraverse(this.scene, o => {
      if (o.geometry) {
        o.geometry.dispose();
      }
      if (o.material) {
        if (o.material.length) {
          for (let i = 0; i < o.material.length; ++i) {
            o.material[i].dispose();
          }
        } else {
          o.material.dispose();
        }
      }
    });

    this.scene.dispose();
    this.scene = null;
    this.camera = null;
    // this.renderer.renderLists.dispose();
    this.renderer = null;

    // console.log("Dispose!");
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
    this.renderer.domElement.removeEventListener('mousemove', this.onMouseMove);
    this.renderer.domElement.removeEventListener('mousedown', this.onMouseDown);
    window.cancelAnimationFrame(this.rAF.id);
    this.dispose();
    this.setState = (state, callback) => {
      return;
    };
    this._isMounted = true;
  }

  render() {
    return (
      <div
        id="configuratorPanel"
        className="configurator--margin-top"
        ref={ref => (this.mount = ref)}
      />
    );
  }
}

export default BrwScene;
